'use strict';

var formValidation = require('base/components/formValidation');
var utils = require('../components/utils');

/**
 * Generates the modal window on the first call.
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function getModalHtmlElement(data, button) {
    if ($('.wishlistModal').length !== 0) {
        $('.wishlistModal').remove();
    }

    if (data.isFavorite) {
        var htmlString = '<div class="modal fade wishlistModal" data-backdrop="false" role="dialog">'
        + '<div class="modal-dialog modal-dialog-centered">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-body text-center">'
        + '    <p class="wishlist-message">' + data.msg + '</p>'
        + '    <a href="' + data.wishlistUrl + '" class="wishlist-link">' + data.wishlistText + '</a>'
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>';

        var $htmlElement = $(htmlString);

        $('.add-to-wish-list-container').append($htmlElement);

        $('.wishlistModal').modal('show');

        setTimeout(function () {
            $('.wishlistModal').modal('hide');
        }, 3000);

        button.removeAttr('disabled');
    }
}

var wishlistSubmit = function ($this, url, isFavorite, pid, optionId, optionVal, wishlistUrl, wishlistText, button) {
    $.ajax({
        url: url,
        type: isFavorite ? 'get' : 'post',
        dataType: 'json',
        data: {
            pid: pid,
            optionId: optionId,
            optionVal: optionVal,
            rurl: window.location.href
        },
        success: function (data) {
            if (isFavorite) {
                $this.data('favorited', false);
                $this.removeClass('active');
            } else {
                $this.data('favorited', true);
                $this.addClass('active');
            }
            data.isFavorite = !isFavorite;
            data.wishlistUrl = wishlistUrl;
            data.wishlistText = wishlistText;
            if (data.redirectUrl) {
                window.location.href = data.redirectUrl;
            } else {
                getModalHtmlElement(data, button);
            }
        },
        error: function (err) {
            if (!err.responseJSON.loggedin) {
                var redirectUrl = (window.location.search === '') ? window.location.href + '?' : window.location.href + '&';

                redirectUrl += 'wishlistAction=add&wishlistPid=' + encodeURIComponent(pid) + '&wihslistOptionId=' + encodeURIComponent(optionId) + '&wishlistOptionVal=' + encodeURIComponent(optionVal);

                var $redirectElement = $('<input type="hidden" name="rurlOverride" value="' + redirectUrl + '"/>');

                $('.create-account-link').each(function () {
                    var link = $(this).hasClass('trade') ? $(this).attr('href') + '&' : $(this).attr('href') + '?';
                    link = link + 'rurlOverride=' + encodeURIComponent(redirectUrl);
                    $(this).attr('href', link);
                });

                $('#loginModal form.login').append($redirectElement);
                $('body').trigger('display:loginModal');
            } else if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                getModalHtmlElement(err, button);
            }
        }
    });
};

module.exports = {
    addToWishlist: function () {
        $('.add-to-wish-list').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var isFavorite = $this.data('favorited');
            var url = isFavorite ? $this.data('removeHref') : $this.data('addHref');
            var wishlistUrl = $this.data('wishlistHref');
            var wishlistText = $this.data('wishlistText');
            var button = $this;
            var pid = $this.data('pid');
            var optionId = $this.closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $this.closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            $this.attr('disabled', true);

            wishlistSubmit($this, url, isFavorite, pid, optionId, optionVal, wishlistUrl, wishlistText, button);
        });

        (function () {
            var qs = function (keyOld) {
                var key = keyOld.replace(/[*+?^$.[\]{}()|\\/]/g, '\\$&'); // escape RegEx meta chars
                var match = location.search.match(new RegExp('[?&]' + key + '=([^&]+)(&|$)'));
                return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
            };

            if (qs('wishlistAction') === 'add') {
                var $this = $('.add-to-wish-list').first();
                var button = $this;
                var isFavorite = false;
                var pid = qs('wishlistPid');
                var optionId = qs('wishlistOptionId');
                var optionVal = qs('wishlistOptionVal');
                var wishlistUrl = $this.data('wishlistHref');
                var wishlistText = $this.data('wishlistText');
                var url = $this.data('addHref');
                wishlistSubmit($this, url, isFavorite, pid, optionId, optionVal, wishlistUrl, wishlistText, button);
                window.history.pushState({}, document.title, window.location.href.replace(window.location.search, ''));
            }
        }());
    },
    login: function () {
        $('form.login').off('submit').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            e.stopImmediatePropagation();
            var url = form.attr('action');
            form.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                    } else {
                        $('form.login').trigger('login:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });
    },
    showSuccessModal: function () {
        var showModal = utils.getParameter('successWishlist');
        var $addToWishlist = $('.add-to-wish-list');

        var isFavorite = $addToWishlist.data('favorited');
        var wishlistUrl = $addToWishlist.data('wishlistHref');
        var wishlistText = $addToWishlist.data('wishlistText');
        var wishlistMsg = $addToWishlist.data('successMsg');
        var data = {};

        data.isFavorite = isFavorite;
        data.wishlistUrl = wishlistUrl;
        data.wishlistText = wishlistText;
        data.msg = wishlistMsg;

        if (isFavorite && showModal === 'true') {
            $(document).on('pageLoaded:init', function () {
                getModalHtmlElement(data, $addToWishlist);

                // remove 'successWishlist' parameter so when page is reloaded event will not be fired
                history.replaceState && history.replaceState(null, '', location.pathname + location.search.replace(/[\?&]successWishlist=[^&]+/, '').replace(/^&/, '?')); // eslint-disable-line
            });
        }
    },

    closeWishlistOnClick: function () {
        $('body').on('click', function (e) {
            // hide wishlist modal if its opened and user clicks outside of it
            if (!$('.wishlistModal').has(e.target).length && $('.wishlistModal').hasClass('show') && !$(e.target).hasClass('wishlistModal')) {
                $('.wishlistModal').modal('hide');
            }
        });
    }
};
